import { Flex } from "@/atoms"
import { RiskTooltipDescription } from "./RiskTooltipDescription"

import type { RiskTooltipContentProps } from "./RiskTooltip.types"

export const RiskTooltipContent = (props: RiskTooltipContentProps) => {
  const { riskId, publishedOn, aliases, noPublishedOn, onExternalLinkClick } =
    props

  return (
    <Flex vertical gap={15}>
      <RiskTooltipDescription
        riskId={riskId}
        publishedOn={publishedOn}
        noPublishedOn={noPublishedOn}
        onExternalLinkClick={onExternalLinkClick}
      />
      {aliases?.map((alias) => (
        <RiskTooltipDescription
          noPublishedOn={noPublishedOn}
          riskId={alias.id}
          publishedOn={alias.publishedOn}
          key={alias.id}
          onExternalLinkClick={onExternalLinkClick}
        />
      ))}
    </Flex>
  )
}
